import { memo } from "react";

const STEPS = [
  { key: "not_started", label: "Invite accepted" },
  { key: "in_progress", label: "Onboarding in progress" },
  { key: "completed", label: "All items complete" },
  { key: "approved", label: "Approved by Reelty" },
];
const ORDER = ["not_started", "in_progress", "completed", "approved"];

function StatusTimelineBase({ status }) {
  const currentIdx = ORDER.indexOf(status);
  return (
    <div className="card-surface rounded-sm p-6" data-testid="status-timeline-card">
      <h3 className="font-display text-lg font-bold mb-4 text-[#1A0F0A]">Your journey</h3>
      <ol className="space-y-4">
        {STEPS.map((step, idx) => {
          const active = idx <= currentIdx;
          return (
            <li key={step.key} className="flex items-start gap-3">
              <div
                className={`mt-0.5 w-2.5 h-2.5 rounded-full ${active ? "bg-[#6B0F1A]" : "bg-[#1A0F0A]/12"}`}
                style={active ? { boxShadow: "0 0 8px #6B0F1A55" } : {}}
              />
              <div>
                <div className={`text-sm font-medium ${active ? "text-[#1A0F0A]" : "text-[#78584B]"}`}>{step.label}</div>
                <div className="font-mono-tag text-[9px] text-[#A89684] mt-0.5">STEP {String(idx + 1).padStart(2, "0")}</div>
              </div>
            </li>
          );
        })}
      </ol>
      {status !== "approved" && (
        <p className="text-[11px] text-[#78584B] mt-5 leading-relaxed">
          Once you complete every step, a Reelty admin reviews and approves your account.
        </p>
      )}
    </div>
  );
}

export const StatusTimeline = memo(StatusTimelineBase);
